import { FormControl, IconButton, MenuItem, Select } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Image from "../../../components/Images/Image";
import InputField from "../../../components/formControl/input/InputField";
import RadioButtonsGroup from "../../../components/radio-button/RadioButtonsGroup";
import SelectInput from "../../../components/select";
import {
  searchBrandsList,
  searchCategoryList,
  searchMerchantList,
} from "../../../redux/actions/merchant-center.action";
import "../../../static/css/productCss/allProduct.css";
import { countriesList } from "../../../lib/countriesList";
import {
  open_dialog,
  parseParam,
  parseQuery,
  showToast,
  startLoader,
  stopLoader,
  UploadImage,
  UploadVideo,
} from "../../../lib/global";
import {
  createNewProduct,
  getProductById,
  updateProduct,
} from "../../../redux/actions/product.action";
import SvgIcon from "../../../components/Images/SvgIcon";
import { breadcrumbAction } from "../../../redux/actions/config.action";
import {
  CANCEL_EDIT_MODAL,
  CATEGORY_SELECTION_DIALOG,
} from "../../../lib/constant";
import { stateName } from "../../../shared/language";
import SelectDropdown from "../../../components/select";
import { MAX_IMAGE_SIZE } from "../../../lib/config";
import ImageModal from "../../../components/carousel/modal";
import { getLocalStorage } from "../../../lib/session";

const productTypes = [
  { label: "Physical", value: "physical" },
  { label: "Non-Physical", value: "non-physical" },
];
const initialCommRate = {
  commRate: "",
  prelaunchPromo: "",
  commStartDate: "",
  commEndDate: "",
};

const statusConstant = {
  New: "NEW",
  Publish: "PUBLISHED",
  Draft: "DRAFT",
  Reject: "REJECTED",
  Deactivate: "DEACTIVATED",
  Delete: "DELETED",
};

const ViewProduct = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [editProduct, setEditProduct] = useState(false);
  const [productId, setProductId] = useState();
  const [errors, setErrors] = useState({});
  const [steps, setSteps] = useState(1);
  const [merchantList, setMerchantList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [videoFile, setVideoFile] = useState();
  const [videoUrl, setVideoUrl] = useState();
  const [variationInfo, setVariationInfo] = useState({});
  const [custumCommRate, setCustumCommRate] = useState("closeCustum");
  const [editStatusText, setEditStatusText] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const role = getLocalStorage("role");
  const storeId = role == "MERCHANT" ? getLocalStorage("storeId") : null;

  var productStatus = useRef("");
  var statusOptions = ["Publish"];

  const [basicInformation, setBasicInformation] = useState({
    title: "",
    merchant: null,
    category: null,
    images: [],
    video: "",
    description: "",
    type: "",
    preOrder: false,
  });
  const [commRateInfo, setCommRateInfo] = useState(initialCommRate);
  const [salesInformation, setSalesInformation] = useState({
    variation: false,
    price: null,
    stock: null,
  });
  const [variations, setVariations] = useState([]);
  const [teamPurchaseInfo, setTeamPurchaseInfo] = useState({
    price: null,
    member: 0,
    unitCapped: 0,
    stock: null,
  });
  const [specification, setSpecification] = useState({
    brand: null,
    shipFrom: null, // country
    warrantyPeriod: null, // in months
    expiryDate: null,
  });
  const [shippingInfo, setShippingInfo] = useState({
    weight: null,
    parcelWidth: null,
    parcelHeight: null,
    parcelLength: null,
    shippingFee: null,
    coverShippingFee: false,
  });

  const [variationData, setVariationData] = useState([]);

  const aa = variations.map((item) => item.name);

  useEffect(() => {
    const breadcrumb = [
      { label: "Products", url: "/products/all-products" },
      { label: "View Product", url: null },
    ];
    dispatch(breadcrumbAction(breadcrumb));
    const paramList = parseParam(history.location.pathname);
    if (paramList && paramList[1] === "view") {
      setEditProduct(true);
      const { id } = parseQuery(history.location.search) || {};
      setProductId(id);
      getProductDetail(id);
    }
    getMerchantList();
    getCategiesList();
    getBrandsList();
  }, []);

  const getProductDetail = (productId) => {
    dispatch(getProductById(productId))
      .then((response) => {
        if (response?.data?.data) {
          if (role == "MERCHANT" && response?.data?.data?.storeId != storeId) {
            history.push("/404");
          }
          const result = response.data.data;
          setBasicInformation((prev) => ({
            ...prev,
            title: result.title,
            merchant: {
              // label: result.merchantName,
              label: result.merchant.preferredMerchantName,
              value: result.storeId,
              flexOption:
                result.merchant.flexOption || prev.merchant?.flexOption,
            },
            category: {
              id: result.categoryId,
              title: result.categoryName,
            },
            images: result.productImages || [],
            video: result.productVideo,
            description: result.description,
            type: result.productType,
            preOrder: !!result.preOrder,
            productStatus: result.statusText,
          }));
          // setCommRateInfo(result.commRate);
          // setProductStatus(result.statusText)
          setEditStatusText(result.statusText);
          productStatus.current = result.statusText;

          setImageUrls(result.productImages || []);
          setVideoUrl(result.productVideo);
          setVariations(result.variation);
          setVariationData(result.variationList);
          setSalesInformation({
            variation: result.variation?.length,
            price: result.price,
            stock: result.stock,
          });
          setSpecification({
            brand: {
              label: result.brand,
              value: result.brandId == "undefined" ? "" : result.brandId,
            },
            shipFrom: {
              label: result.shipFrom,
              value: result.shipFrom,
            }, // country
            warrantyPeriod: result.warranty,
            expiryDate: result.expiryDate,
          });
          setTeamPurchaseInfo({
            price: result.teamPurchasePrice,
            member: result.teamPurchaseMember,
            unitCapped: result.unitCapped,
            stock: result.teamPurchaseStock,
          });
          setShippingInfo({
            weight: result.shippingInfo?.weight,
            parcelWidth: result.shippingInfo?.parcelSize?.width,
            parcelHeight: result.shippingInfo?.parcelSize?.height,
            parcelLength: result.shippingInfo?.parcelSize?.length,
            shippingFee: result.shippingInfo?.shippingFee,
            coverShippingFee: !!result.shippingInfo?.coverShippingFee,
          });
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  };
  const getMerchantList = (search) => {
    dispatch(searchMerchantList(search))
      .then((response) => {
        if (response?.data?.data) {
          const data = response.data.data.map((item) => ({
            title: item.merchantName,
            // label: `${item.merchantName} - (${item.storeId})`,
            label: `${item.preferredMerchantName} - (${item.storeId})`,
            value: item.storeId,
            flexOption: item.flexOption,
          }));
          setMerchantList(data);
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  };
  const getCategiesList = (search) => {
    dispatch(searchCategoryList(search))
      .then((response) => {
        if (response?.data?.data) {
          const data = response.data.data.map((item) => ({
            label: item.title,
            value: item.id,
          }));
          setCategoryList(data);
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  };
  const getBrandsList = (search) => {
    dispatch(searchBrandsList(search))
      .then((response) => {
        // console.log(response, "fffffffffffffffffffffffffffff");
        if (response?.data?.data) {
          const data = response.data.data.map((item) => ({
            label: item.brandName,
            value: item.brandId,
          }));
          setBrandsList(data);
        }
      })
      .catch((error) => {
        console.log({ error });
      });
  };

  const onChangeBasicInfo = (e, opt, val) => {
    console.log("val", val);
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setBasicInformation((pre) => ({ ...pre, [key]: value }));
  };
  const onChangeCommRateInfo = (e, opt, val) => {
    console.log("kashi", val);
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setCommRateInfo((pre) => ({ ...pre, [key]: value }));
  };
  const onChangeSalesInfo = (e, opt, val) => {
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setSalesInformation((pre) => ({ ...pre, [key]: value }));
  };
  const onChangeTeamPurchaseInfo = (e, opt, val) => {
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setTeamPurchaseInfo((pre) => ({ ...pre, [key]: value }));
  };
  const onChangeSpecification = (e, opt, val) => {
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setSpecification((pre) => ({ ...pre, [key]: value }));
  };
  const onChangeShippingInfo = (e, opt, val) => {
    const key = opt || e.target.name;
    const value = val || e.target.value;
    setShippingInfo((pre) => ({ ...pre, [key]: value }));
  };

  const handleUploadFile = async (e, index) => {
    const fileData = e.target.files[0];
    if (fileData.size > MAX_IMAGE_SIZE) {
      showToast(
        `Image with size more than ${MAX_IMAGE_SIZE / 1000000
        }MB is not supported.\nPlease upload image of size smaller than ${MAX_IMAGE_SIZE / 1000000
        }MB.\nCurrent file size: ${(fileData.size / 1000000).toFixed(2)}MB`,
        "error",
        3000,
        "bottom",
        "center"
      );
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(fileData);
    reader.onload = function () {
      const fileIns = [...imageFiles];
      console.log(imageUrls);
      const imageUrlIns = [...imageUrls];
      if (fileIns[index]) {
        fileIns[index] = fileData;
        imageUrlIns[index] = reader.result;
      } else {
        fileIns.push(fileData);
        imageUrlIns.push(reader.result);
      }
      setImageFiles(fileIns);
      setImageUrls(imageUrlIns);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };
  const handleUploadVideoFile = async (e) => {
    const fileData = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(fileData);
    reader.onload = function () {
      setVideoFile(fileData);
      setVideoUrl(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const validateBasicInfo = () => {
    const errorsList = {
      merchant: "",
      title: "",
      category: "",
      images: "",
      description: "",
      type: "",
    };
    if (!basicInformation.merchant) {
      errorsList.merchant = "Merchant";
    }
    if (!basicInformation.title) {
      errorsList.title = "Product Name";
    }
    if (!basicInformation.category) {
      errorsList.category = "Category";
    }
    if (!imageFiles?.length && !imageUrls?.length) {
      errorsList.images = "Images";
    }
    if (!basicInformation.description) {
      errorsList.description = "Product Description";
    }
    if (!basicInformation.type) {
      errorsList.type = "Product Type";
    }
    setErrors((pre) => ({ ...pre, ...errorsList }));
    return errorsList;
  };
  const validateSalesInfo = () => {
    console.log(salesInformation, teamPurchaseInfo, "kkkkkkkkkkkkkkkk");
    const errorsList = {
      price: "",
      stock: "",
      teamPurchasePrice: "",
      teamPurchaseStock: "",
      unitCapped: "",
      teamPurchaseMember: "",
    };
    if (!salesInformation.price) {
      errorsList.price = "Product Price";
    }
    if (!salesInformation.stock) {
      errorsList.stock = "Product Stock";
    }
    if (!teamPurchaseInfo.price) {
      errorsList.teamPurchasePrice = "Team Price";
    }
    if (!teamPurchaseInfo.member) {
      console.log("teamPurchaseInfo.member", teamPurchaseInfo.member);
      errorsList.teamPurchaseMember = "Team Member";
    }
    if (!teamPurchaseInfo.stock) {
      errorsList.teamPurchaseStock = "Team Product Stock";
    }
    if (!teamPurchaseInfo.unitCapped) {
      errorsList.unitCapped = "Unit Capped";
    }
    setErrors((pre) => ({ ...pre, ...errorsList }));
    return errorsList;
  };
  const validateVariationInfo = () => {
    console.log(variationData, "mmmmmm");
    const errorsList = {
      price: "",
      teamPrice: "",
      teamMembers: "",
      variation: "",
      variationData: "",
    };
    variationData.map((item) => {
      if (!item.price) {
        errorsList.price = "Individual Price";
      }
      if (!item.teamPrice) {
        errorsList.teamPrice = "Team Price";
      }
      if (!item.teamMembers) {
        errorsList.teamMembers = "Team Members";
      }
    });
    if (variations.length) {
      if (!variations[0]?.name || !variations[0].options?.length) {
        errorsList.variation = "Variation";
      }
      if (!variationData.length) {
        errorsList.stock = "Variation List";
      }
    }

    setErrors((pre) => ({ ...pre, ...errorsList }));
    return errorsList;
  };
  const validateShippingInfo = () => {
    const errorsList = {
      shipFrom: "",
      warrantyPeriod: "",
      weight: "",
      parcelSize: "",
      shippingFee: "",
      brand: "",
    };
    console.log(specification, "qqqqqqqqqqqqqbbbbbbbbbbbbbbbbbb");
    if (!specification.shipFrom.value) {
      errorsList.shipFrom = "Ship from";
    }
    // if (!specification.brand.value) {
    //     errorsList.brand = "Brand Name";
    // }
    if (basicInformation.type == "non-physical") {
      if (!specification.expiryDate) {
        errorsList.expiryDate = "Expiry Date";
      }
    }
    if (basicInformation.type == "physical") {
      if (
        !specification.warrantyPeriod ||
        specification.warrantyPeriod == "null"
      ) {
        errorsList.warrantyPeriod = "Warranty";
      }
      if (!shippingInfo.weight) {
        errorsList.weight = "Product Weight";
      }
      if (
        !shippingInfo.parcelHeight ||
        !shippingInfo.parcelWidth ||
        !shippingInfo.parcelLength
      ) {
        errorsList.parcelSize = "Parcel Size";
      }
    }

    setErrors((pre) => ({ ...pre, ...errorsList }));
    console.log(errorsList, "bbbbbbbbbbbbbbbbbb");
    return errorsList;
  };

  // let errorData = { ...validateBasicInfo(), ...validateVariationInfo(), ...validateShippingInfo(), }
  const handleClickNext = async () => {
    console.log(productStatus, "enter");
    setErrors({});
    try {
      const error = {
        ...validateBasicInfo(),
        ...validateVariationInfo(),
        ...validateShippingInfo(),
      };
      console.log(error, "ccccccccccccccccccc");
      if (Object.values(error).filter((item) => item).length) {
        stopLoader();
        return;
      }

      console.log(productStatus, "ghjkl1111111111111");
      console.log(null || "", "ghjk");
      const payload = {
        merchantName: basicInformation.merchant?.title,
        storeId: String(basicInformation.merchant?.value),
        title: basicInformation.title,
        categoryId: String(basicInformation.category?.id),
        categoryName: basicInformation.category?.title,
        productImages: basicInformation.images,
        productVideo: basicInformation.video,
        description: basicInformation.description,
        productType: basicInformation.type,
        variation: variations,
        variationList: variationData,
        // price: String(salesInformation.price),
        currencyName: "RM",
        // statusText: basicInformation.productStatus,
        statusText: productStatus.current,

        stock: Number(salesInformation.stock),
        teamPurchasePrice: Number(teamPurchaseInfo.price),
        teamPurchaseStock: Number(teamPurchaseInfo.stock),
        teamPurchaseMember: Number(teamPurchaseInfo.member),
        unitCapped: Number(teamPurchaseInfo.unitCapped),
        brand: specification.brand?.label || "",

        brandId: String(specification.brand?.value) || "",
        shipFrom: specification.shipFrom?.label || "",
        warranty: String(specification.warrantyPeriod) || "",
        expiryDate: String(specification.expiryDate) || "",
        shippingInfo: {
          weight: Number(shippingInfo.weight) || "",
          parcelSize: {
            height: Number(shippingInfo.parcelHeight) || "",
            width: Number(shippingInfo.parcelWidth) || "",
            length: Number(shippingInfo.parcelLength) || "",
          },
          shippingFee: shippingInfo.shippingFee || "", // object
        },
        preOrder: basicInformation.preOrder,
      };
      // uploading product images and videos
      console.log("ghjkl");
      let images = [];
      for (let file of imageFiles) {
        let url = await UploadImage(file);
        // console.log(url?.error?.message, 'jjjjjjjjjj');
        // if (url?.error) {
        //   showToast(url?.error?.message || "file size is too big", 'error')
        // }
        // else {
        images.push(url);
        // }
      }
      payload.productImages = [...payload.productImages, ...images];
      if (videoFile) {
        let videoUrl = await UploadVideo(videoFile);
        payload.productVideo = videoUrl;
      }

      console.log(JSON.stringify(payload, null, "  "));
      if (editProduct) {
        dispatch(updateProduct(payload, productId))
          .then((response) => {
            stopLoader();
            console.log("Product updated successfully");
            history.push("/products/all-products");
          })
          .catch((error) => {
            stopLoader();
            const message = JSON.parse(error.request.responseText).message;
            showToast("Fail Save Product [" + message + "]", "error");
            console.error("Failed to upload product!", error);
          });
      } else {
        dispatch(createNewProduct(payload))
          .then((response) => {
            stopLoader();
            console.log("Product uploaded successfully");
            history.push("/products/all-products");
          })
          .catch((error) => {
            stopLoader();
            const message = JSON.parse(error.request.responseText).message;
            showToast("Fail Save Product [" + message + "]", "error");
            console.error("Failed to upload product!", error);
          });
      }
    } catch (error) {
      console.log(error);
      stopLoader();
    }
  };

  const handleAddVariationOption = (varitionIndex) => {
    const variationIns = [...variations];
    variationIns[varitionIndex].options.push("");
    setVariations(variationIns);
    handleGenerateVariationTable();
  };
  const handleDeleteVariationOption = (varitionIndex, optionIndex) => {
    if (optionIndex > 0) {
      const variationIns = [...variations];
      variationIns[varitionIndex].options.splice(optionIndex, 1);
      setVariations(variationIns);
      handleGenerateVariationTable();
    }
  };

  const handleChangeVariationName = (e, variationNumber) => {
    const value = e.target.value;
    const variationIns = [...variations];
    variationIns[variationNumber].name = value;
    setVariations(variationIns);
    handleGenerateVariationTable();
  };

  const handleChangeVariationOption = (e, variationIndex, optionIndex) => {
    const value = e.target.value;
    const variationIns = [...variations];
    variationIns[variationIndex].options[optionIndex] = value;
    setVariations(variationIns);
    handleGenerateVariationTable();
  };

  const handleAddMoreVariation = () => {
    setVariations((pre) => [...pre, { name: "", options: [""] }]);
  };

  const addVariation = () => {
    setVariations([{ name: "", options: [""] }]);
    onChangeSalesInfo(null, "variation", true);
  };

  const handleDeleteVariation = (variationIndex) => {
    if (variations.length <= 1) {
      setVariations([]);
      setVariationData([]);
      setSalesInformation((pre) => ({ ...pre, variation: false }));
    } else {
      const variationIns = [...variations];
      variationIns.splice(variationIndex, 1);
      setVariations(variationIns);
    }
  };

  const handleGenerateVariationTable = () => {
    const dataArray = [];
    const firstVariationName = variations[0].name;
    const firstVariationOptions = variations[0].options;
    for (let firstVariation of firstVariationOptions) {
      for (let variationIndex in variations) {
        if (variations.length == 1) {
          if (firstVariation) {
            let data = {
              price: null,
              stock: null,
              sku: "",
              [firstVariationName]: firstVariation,
              teamPrice: null,
              teamMembers: null,
              teamUnitCapped: null,
              teamStock: null,
              teamSku: "",
            };
            dataArray.push(data);
          }
        } else {
          if (variationIndex > 0) {
            let name = variations[variationIndex].name;
            for (let opt of variations[variationIndex].options) {
              if (opt) {
                let data = {
                  price: null,
                  stock: null,
                  sku: "",
                  [firstVariationName]: firstVariation,
                  [name]: opt,
                  teamPrice: null,
                  teamMembers: null,
                  teamUnitCapped: null,
                  teamStock: null,
                  teamSku: "",
                };
                dataArray.push(data);
              }
            }
          }
        }
      }
    }
    setVariationData(dataArray);
  };
  const handleVariationDataChange = (e, key, index) => {
    const value = e.target.value;
    const dataIns = [...variationData];
    dataIns[index][key] = value;
    setVariationData(dataIns);
  };

  const onChangeVariationInfo = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setVariationInfo((pre) => ({ ...pre, [key]: value }));
  };
  const handleApplyAll = () => {
    if (!variationInfo.unitCapped || !variationInfo.stock) {
      return;
    }
    const variationDataIns = [...variationData];
    const data = variationDataIns.map((item) => ({
      ...item,
      sku: variationInfo.sku,
      teamSku: variationInfo.sku,
      stock: variationInfo.stock,
      unitCapped: variationInfo.unitCapped,
      teamStock: variationInfo.stock,
      teamUnitCapped: variationInfo.unitCapped,
    }));
    setVariationData(data);
  };

  const handleSelectCategory = () => {
    open_dialog(CATEGORY_SELECTION_DIALOG, {
      onSubmit: onSelectCategory,
      activeCategory: basicInformation.category,
      maxWidth: "70vw",
    });
  };
  const onSelectCategory = (data) => {
    console.log("data", data);
    onChangeBasicInfo(null, "category", data);
  };

  const onCancelCommRate = () => {
    setCommRateInfo(initialCommRate);
    setCustumCommRate("closeCustum");
  };

  const CancelEditing = () => {
    open_dialog(CANCEL_EDIT_MODAL, {
      goBackUrl: "/products/all-products",
    });
  };
  if (editStatusText == "NEW") {
    statusOptions = [...statusOptions, "Reject"];
  } else if (editStatusText == "PUBLISHED") {
    statusOptions = [...statusOptions, "Reject", "Deactivate"];
  }
  const changeProductStatus = (e) => {
    productStatus.current = e.target.value;
    console.log(productStatus, "ooooooooooo");
  };

  const viewModalImage = (e, index) => {
    setModalIsOpen(!modalIsOpen);
  };
  return (
    <React.Fragment>
      <div>
        <div
          id="basic-info-container"
          //   visible={String(steps == 1)}
          className="mr-3 ml-4 rounded mb-2 px-3 pt-4 bg-white"
        >
          <h6> BASIC INFORMATION </h6>
          <form className="mt-3 mb-2 p-0">
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Merchant
              </label>
              <div className="form-group col-9">
                <SelectInput
                  options={merchantList}
                  name="merchant"
                  value={basicInformation.merchant}
                  // onChange={(e) => onChangeBasicInfo(e, "merchant", e)}
                  required={true}
                  formSubmitted={false}
                  placeholder="Select Merchant"
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-12 row my-3">
              <label
                htmlFor="product-name"
                className="col-3 text-right m-0 p-0 small imp"
              >
                Product Name
              </label>
              <InputField
                className=""
                formClass="col-9"
                type="text"
                id="product-name"
                placeholder="Product Name..."
                name="title"
                value={basicInformation.title}
                onChange={onChangeBasicInfo}
                required={true}
                disabled
              />
            </div>

            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Category
              </label>
              <div className="form-group mb-1 col-9">
                <div
                  // onClick={handleSelectCategory}
                  className="col border form-control pointer bg-muted"
                  disabled
                >
                  {basicInformation.category?.title || (
                    <p className="text-muted">Select Category</p>
                  )}
                </div>
              </div>
            </div>

            {/*----------------Edit---------------- */}

            {/* <div className=" col-12 row mb-3">
                            <label className="col-3 text-right m-0 p-0 pt-2 small">
                                Comm Rate
                            </label>
                            <div className="form-group col-3 mb-0">
                                <InputField
                                    className="form-control"
                                    type="text"
                                    // id="product-name"
                                    placeholder="Comm Rate"
                                    disabled
                                    name="commRate"
                                    value={commRateInfo?.commRate}
                                    onChange={onChangeCommRateInfo}
                                    
                                // required={true}
                                />
                            </div>
                            <div
                                className={`pt-2 d-${custumCommRate == "closeCustum" ? "block" : "none"
                                    }`}
                            >
                                <IconButton

                                    disabled
                                    onClick={() => setCustumCommRate("openCustum")}
                                    className="pointer pt-2"
                                >
                                    <SvgIcon src="/icons/edit_icon.svg" alt="view icon" />
                                </IconButton>
                            </div>
                        </div>

                        <div
                            className={`d-${custumCommRate == "openCustum" ? "block" : "none"
                                }`}
                        >
                            <div className="row mb-3">
                                <div className="col-3"> </div>
                                <div className="col-6">
                                    <textarea
                                        // id="textarea"
                                        className="form-control"
                                        style={{ minHeight: "20vh" }}
                                        placeholder="Prelaunch Promo..."
                                        name="prelaunchPromo"
                                        value={commRateInfo?.prelaunchPromo}
                                        // onChange={onChangeCommRateInfo}
                                      readOnly={true}
                                      disabled
                                    // required={true}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-3 text-right m-0 p-0 pt-2 small">
                                    Period
                                </label>
                                <div className="col-6 form-group">
                                    <div className="col-12 row">
                                        <input
                                            type="date"
                                            name="commStartDate"
                                            value={commRateInfo?.commStartDate}
                                            onChange={onChangeCommRateInfo}
                                            // required={true}
                                            disabled
                                            className="col-5 form-control"
                                        />
                                        <div className="col-2"></div>
                                        <input
                                            type="date"
                                            name="commEndDate"
                                            value={commRateInfo?.commEndDate}
                                            onChange={onChangeCommRateInfo}
                                            disabled
                                                                     // required={true}
                                            className="col-5 form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-5 ">
                                <div className="col-3"> </div>
                                <div className="col-6">
                                    <div className="d-flex flex-row justify-content-end">
                                        <div
                                            onClick={() => onCancelCommRate()}
                                            className="btn btn-outline-secondary mx-1"
                                        >
                                            Cancel
                                        </div>
                                        <div
                                            onClick={() => setCustumCommRate("closeCustum")}
                                            className="btn btn-secondary mx-1"
                                        >
                                            Save
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            <ImageModal
              modalIsOpen={modalIsOpen}
              setModalIsOpen={setModalIsOpen}
              imageUrls={imageUrls}
            />

            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Product Images
              </label>
              <div className="icon-button-file col">
                <IconButton
                  className="m-0 mb-1 p-0 small pointer"
                  onClick={(e) => viewModalImage(e)}
                >
                  <SvgIcon src="/icons/view_icon.svg" alt="view icon" />
                </IconButton>
                <div className="icon-button-file col-12 d-flex flex-wrap">
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
                    <div className="ml-n3 mx-5 mb-2" key={item}>
                      <input
                        accept="image/*"
                        id={`product-image-${item}`}
                        className="d-none"
                        onChange={(e) => handleUploadFile(e, item)}
                        multiple={false}
                        type="file"
                        disabled
                      />
                      <label htmlFor={`product-image-${item}`}>
                        <Image
                          src={imageUrls?.[item] || "/icons/upload_icon.svg"}
                          alt="upload"
                          className={`pointer upload_image_label`}
                        />
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small">
                Product Video
              </label>
              <div className="icon-button-file col-9">
                <div className="m-0">
                  <input
                    accept="video/*"
                    id={`product-video`}
                    className="d-none"
                    onChange={(e) => handleUploadVideoFile(e)}
                    multiple={false}
                    type="file"
                    disabled
                  />
                  <label htmlFor={`product-video`}>
                    {videoUrl ? (
                      <video width="80" height="80" controls>
                        <source src={videoUrl} type="video/mp4" />
                      </video>
                    ) : (
                      <Image
                        src={"/icons/upload_icon.svg"}
                        alt="upload"
                        className={`pointer upload_image_label`}
                      />
                    )}
                  </label>
                </div>
              </div>
            </div>

            <div className="col-12 row">
              <label
                htmlFor="merchantId"
                className="col-3 text-right small imp"
              >
                Description
              </label>
              <div className="col-9 d-flex">
                <textarea
                  type="text"
                  id="description"
                  name="description"
                  value={basicInformation.description}
                  onChange={onChangeBasicInfo}
                  className={"form-control"}
                  placeholder="Enter product description..."
                  rows={3}
                  disabled
                ></textarea>
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 my-auto text-right small imp">
                Product Type
              </label>
              <RadioButtonsGroup
                options={productTypes}
                name="product-type"
                className="col-9 px-3"
                value={basicInformation.type}
                // onChange={(e) => onChangeBasicInfo(e, "type", e.target.value)}
                disabled
              />
            </div>
          </form>
        </div>

        {/*<div*/}
        {/*    id="sales-info-conatainer"*/}
        {/*    //   visible={String(!salesInformation.variation)}*/}
        {/*    visible={String(!salesInformation.variation)}*/}

        {/*    className="mr-3 ml-4 rounded  px-3 pt-4 pb-2 bg-white"*/}
        {/*>*/}
        {/*    <h6 className="my-0">SALES INFORMATION</h6>*/}
        {/*    <form className="mt-3  p-0">*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Variation*/}
        {/*            </label>*/}
        {/*            <div className="form-group col-9">*/}
        {/*                <button*/}
        {/*                    disabled*/}
        {/*                    type="button"*/}
        {/*                    onClick={addVariation}*/}
        {/*                    className="btn btn-outline-dark "*/}
        {/*                >*/}
        {/*                    + Add Variation*/}
        {/*                </button>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Price*/}
        {/*            </label>*/}
        {/*            <div className="col-9">*/}
        {/*                <InputField*/}
        {/*                    className="input_icon_left"*/}
        {/*                    formClass="col-12 p-0"*/}
        {/*                    type="number"*/}
        {/*                    id="individual-price"*/}
        {/*                    icon="currency"*/}
        {/*                    placeholder="Input"*/}
        {/*                    name="price"*/}
        {/*                    min="0"*/}
        {/*                    value={salesInformation.price}*/}
        {/*                    onChange={onChangeSalesInfo}*/}
        {/*                    required={true}*/}
        {/*                    disabled*/}
        {/*                />*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Stock*/}
        {/*            </label>*/}
        {/*            <div className="form-group col-9">*/}
        {/*                <InputField*/}
        {/*                    className=""*/}
        {/*                    formClass="col-12 p-0"*/}
        {/*                    type="number"*/}
        {/*                    min="0"*/}
        {/*                    id="stock"*/}
        {/*                    placeholder="Input"*/}
        {/*                    name="stock"*/}
        {/*                    value={salesInformation.stock}*/}
        {/*                    onChange={onChangeSalesInfo}*/}
        {/*                    required={true}*/}
        {/*                    disabled*/}
        {/*                />*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </form>*/}
        {/*</div>*/}

        {/*<div*/}
        {/*    id="team-buy-container"*/}
        {/*    visible={String(!salesInformation.variation)}*/}
        {/*    className="mr-3 ml-4 mt-3 rounded  px-3 pt-4 pb-2 bg-white"*/}
        {/*>*/}
        {/*    <h6>TEAM BUY INFORMATION</h6>*/}
        {/*    <form className="mt-3  p-0">*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Price*/}
        {/*            </label>*/}
        {/*            <div className="col-9">*/}
        {/*                <InputField*/}
        {/*                    className="input_icon_left"*/}
        {/*                    formClass="col-12 p-0"*/}
        {/*                    type="number"*/}
        {/*                    min="0"*/}
        {/*                    id="team-purchase-price"*/}
        {/*                    icon="currency"*/}
        {/*                    placeholder="Input"*/}
        {/*                    name="price"*/}
        {/*                    value={teamPurchaseInfo.price}*/}
        {/*                    onChange={onChangeTeamPurchaseInfo}*/}
        {/*                    required={true}*/}
        {/*                    disabled*/}
        {/*                />*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Member*/}
        {/*            </label>*/}
        {/*            <div className="col-9 d-flex align-items-center">*/}
        {/*                <button*/}
        {/*                    type="button"*/}
        {/*                    // onClick={(e) =>*/}
        {/*                    //     onChangeTeamPurchaseInfo(*/}
        {/*                    //         e,*/}
        {/*                    //         "member",*/}
        {/*                    //         parseInt(teamPurchaseInfo.member) - 1*/}
        {/*                    //     )*/}
        {/*                    // }*/}
        {/*                    disabled={!teamPurchaseInfo.member}*/}
        {/*                    className="btn btn-light counter_btn bold"*/}

        {/*                >*/}
        {/*                    -*/}
        {/*                </button>*/}
        {/*                <span className="px-3 my-auto">*/}
        {/*                    {teamPurchaseInfo.member || 0}*/}
        {/*                </span>*/}
        {/*                <button*/}
        {/*                    // disabled={!teamPurchaseInfo.member}*/}
        {/*                    type="button"*/}
        {/*                    // onClick={(e) =>*/}
        {/*                    //     onChangeTeamPurchaseInfo(*/}
        {/*                    //         e,*/}
        {/*                    //         "member",*/}
        {/*                    //         parseInt(teamPurchaseInfo.member || 0) + 1*/}
        {/*                    //     )*/}
        {/*                    // }*/}
        {/*                    className="btn btn-light counter_btn bold"*/}
        {/*                    disabled*/}
        {/*                >*/}
        {/*                    +*/}
        {/*                </button>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Unit Capped*/}
        {/*            </label>*/}
        {/*            <div className="col-9 d-flex align-items-center">*/}
        {/*                <button*/}
        {/*                    type="button"*/}
        {/*                    // onClick={(e) =>*/}
        {/*                    //     onChangeTeamPurchaseInfo(*/}
        {/*                    //         e,*/}
        {/*                    //         "unitCapped",*/}
        {/*                    //         parseInt(teamPurchaseInfo.unitCapped) - 1*/}
        {/*                    //     )*/}
        {/*                    // }*/}
        {/*                    disabled={!teamPurchaseInfo.unitCapped}*/}
        {/*                    className="btn btn-light counter_btn bold"*/}
        {/*                >*/}
        {/*                    -*/}
        {/*                </button>*/}
        {/*                <span className="px-3 my-auto">*/}
        {/*                    {teamPurchaseInfo.unitCapped || 0}*/}
        {/*                </span>*/}
        {/*                <button*/}
        {/*                    // disabled={!teamPurchaseInfo.unitCapped}*/}
        {/*                    type="button"*/}
        {/*                    // onClick={(e) =>*/}
        {/*                    //     onChangeTeamPurchaseInfo(*/}
        {/*                    //         e,*/}
        {/*                    //         "unitCapped",*/}
        {/*                    //         parseInt(teamPurchaseInfo.unitCapped || 0) + 1*/}
        {/*                    //     )*/}
        {/*                    // }*/}
        {/*                    className="btn btn-light counter_btn bold"*/}
        {/*                >*/}
        {/*                    +*/}
        {/*                </button>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        <div className="col-12 row my-3">*/}
        {/*            <label className="col-3 text-right m-0 p-0 small imp">*/}
        {/*                Stock*/}
        {/*            </label>*/}
        {/*            <div className="form-group col-9">*/}
        {/*                <InputField*/}
        {/*                    className=""*/}
        {/*                    formClass="col-9 p-0"*/}
        {/*                    type="number"*/}
        {/*                    min="0"*/}
        {/*                    id="team-purchase-stock"*/}
        {/*                    placeholder="Input"*/}
        {/*                    name="stock"*/}
        {/*                    value={teamPurchaseInfo.stock}*/}
        {/*                    onChange={onChangeTeamPurchaseInfo}*/}
        {/*                    required={true}*/}
        {/*                    disabled*/}
        {/*                />*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </form>*/}
        {/*</div>*/}

        <br />
        <div
          id="sales-info-variation"
          // visible={String(salesInformation.variation)}
          // visible={String(salesInformation?.variation ? "true" : "false")}
          visible={String(salesInformation?.variation ? "true" : "true")}
          className="mr-3 ml-4 rounded  px-3 pt-4 pb-2 bg-white"
        >
          <h6 className="my-0">SALES INFORMATION</h6>
          <form className="mt-3  p-0">
            <div className="col-12 row my-3">
              <label
                htmlFor="product-variation"
                className="col-2 text-right m-0 p-0 small imp"
              >
                Variation
              </label>
              <div className="col-10">
                {variations.map((item, variationIndex) => (
                  <div className="local-bg p-3 w-100 my-3">
                    <div className="col-12 row my-3">
                      <label
                        htmlFor="variation-name"
                        className="col-3 small imp text-nowrap"
                      >
                        Name
                      </label>
                      <InputField
                        className="pr-5"
                        formClass="col-9"
                        type="text"
                        id="variation-name"
                        placeholder="Enter variation name eg. colour, size, etc"
                        name="title"
                        value={item.name}
                        onChange={(e) =>
                          handleChangeVariationName(e, variationIndex)
                        }
                        required={true}
                        iconType="text"
                        iconPosition="right"
                        iconLabel={`${item.name?.length || 0}/20`}
                        maxLength={20}
                        disabled
                      />
                    </div>
                    <div className="col-12 row my-3">
                      <label
                        htmlFor="variation-name"
                        className="col-3 small imp text-nowrap"
                      >
                        Options
                      </label>
                      <div className="col-9 p-0">
                        {item.options.map((opt, optIndex) => (
                          <div className="col-12 p-0 my-2 d-flex">
                            <InputField
                              className="pr-5"
                              formClass="col-11"
                              type="text"
                              id="variation-options"
                              placeholder="Enter variation option eg. red, etc"
                              name="variation-options"
                              value={opt}
                              onChange={(e) =>
                                handleChangeVariationOption(
                                  e,
                                  variationIndex,
                                  optIndex
                                )
                              }
                              required={true}
                              iconType="text"
                              iconPosition="right"
                              iconLabel={`${opt?.length || 0}/20`}
                              maxLength={20}
                              disabled
                            />
                            <IconButton
                              onClick={() =>
                                handleDeleteVariationOption(
                                  variationIndex,
                                  optIndex
                                )
                              }
                              className="pointer"
                              disabled
                            >
                              <SvgIcon
                                src="/icons/delete_icon.svg"
                                alt="delete icon"
                              />
                            </IconButton>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-12 row justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-dark mx-2"
                        // onClick={() => handleDeleteVariation(variationIndex)}
                        disabled
                      >
                        delete
                      </button>
                      <button
                        type="button"
                        disabled
                        // onClick={() => handleAddVariationOption(variationIndex)}
                        className="btn btn-dark mx-2"
                      >
                        Add Option
                      </button>
                    </div>
                  </div>
                ))}
                <div className="col-12 mt-3">
                  <button
                    type="button"
                    // onClick={handleAddMoreVariation}
                    visible={String(variations.length < 2)}
                    className="btn btn-outline-dark w-100"
                    disabled
                  >
                    + Add variation
                  </button>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div className="col-12 row mt-3 mb-5">
              <label className="col-2 text-right m-0 p-0 small">
                Variation Information
              </label>
              <div className="col-10 pl-5 row">
                <div className="col-3 px-2">
                  <InputField
                    formClass="col-12 p-0"
                    type="number"
                    min="0"
                    id="unitCapped"
                    placeholder="Unit Capped"
                    name="unitCapped"
                    value={variationInfo.unitCapped}
                    onChange={onChangeVariationInfo}
                    required={true}
                    disabled
                  />
                </div>
                <div className="col-3 px-2">
                  <InputField
                    formClass="col-12 p-0"
                    type="number"
                    min="0"
                    id="stock"
                    placeholder="Stock"
                    name="stock"
                    value={variationInfo.stock}
                    onChange={onChangeVariationInfo}
                    required={true}
                    disabled
                  />
                </div>
                <div className="col-3 px-2">
                  <InputField
                    formClass="col-12 p-0"
                    type="number"
                    min="0"
                    id="sku"
                    placeholder="SKU(Optional)"
                    name="sku"
                    value={variationInfo.sku}
                    onChange={onChangeVariationInfo}
                    required={false}
                    disabled
                  />
                </div>
                <div className="col-3 px-2">
                  <button
                    onClick={handleApplyAll}
                    disabled
                    type="button"
                    className="btn btn-dark btn-sm text-nowrap"
                  >
                    Apply To All
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 my-3 d-flex">
              <label htmlFor="" className="col-2">
                Individual Variation List
              </label>
              <table className="col-10 border p-3 mx-3">
                <tr>
                  {variations &&
                    variations.length > 0 &&
                    variations.map((item, index) => (
                      <th
                        key={index}
                        className="small border py-1 px-2 local-bg"
                      >
                        {item?.name || "-"}
                      </th>
                    ))}
                  <th className="small border py-1 px-2 local-bg">Price</th>
                  <th className="small border py-1 px-2 local-bg">
                    Unit Capped
                  </th>
                  <th className="small border py-1 px-2 local-bg">Stock</th>
                  <th className="small border py-1 px-2 local-bg">SKU</th>
                  <th className="small border py-1 px-2 local-bg">Discount Percentage</th>
                </tr>
                {variationData &&
                  variationData.length > 0 &&
                  variationData
                    .filter((item) => {
                      return (
                        item[variations.map((item) => item.name)[0]]?.trim()
                          .length !== 0
                      );
                    })
                    .map((row, rowIndex) => (
                      <tr className="" key={rowIndex}>
                        {variations.map((item, index) => (
                          <th
                            key={index}
                            className="border px-2 small text-muted"
                          >
                            {row[item.name] || " -"}
                          </th>
                        ))}
                        <td className="border">
                          <InputField
                            formClass="col-12 p-0"
                            className="input-box input-inside-text  border-0 input_icon_left"
                            type="number"
                            min="0"
                            id="price"
                            placeholder="Input"
                            name="price"
                            value={row.price}
                            disabled
                            onChange={(e) =>
                              handleVariationDataChange(e, "price", rowIndex)
                            }
                            required={false}
                            icon="currency"
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="number"
                            min="0"
                            id="unitCapped"
                            placeholder="Input"
                            name="unitCapped"
                            value={row.unitCapped}
                            onChange={(e) =>
                              handleVariationDataChange(
                                e,
                                "unitCapped",
                                rowIndex
                              )
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="number"
                            min="0"
                            id="stock"
                            placeholder="Input"
                            name="stock"
                            value={row.stock}
                            onChange={(e) =>
                              handleVariationDataChange(e, "stock", rowIndex)
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="text"
                            // min="0"
                            id="sku"
                            placeholder="Input (Optional)"
                            name="sku"
                            value={row.sku}
                            onChange={(e) =>
                              handleVariationDataChange(e, "sku", rowIndex)
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="text"
                            disabled
                            id="pointDiscountPercentage"
                            placeholder="Input"
                            name="pointDiscountPercentage"
                            value={basicInformation.merchant?.flexOption !== 'Topping' ? 0 : row.pointDiscountPercentage}
                            onChange={(e) =>
                              handleVariationDataChange(e, "pointDiscountPercentage", rowIndex)
                            }
                            required={false}
                          />
                        </td>
                      </tr>
                    ))}
              </table>
            </div>
            <div className="col-12 my-3 d-flex">
              <label htmlFor="" className="col-2">
                Team Variation List
              </label>
              <table className="col-10 border p-3 mx-3">
                <tr>
                  {variations &&
                    variations.length > 0 &&
                    variations.map((item, index) => (
                      <th
                        key={index}
                        className="small border py-1 px-2 local-bg"
                      >
                        {item?.name || "-"}
                      </th>
                    ))}
                  <th className="small border py-1 px-2 local-bg">TP Price</th>
                  <th className="small border py-1 px-2 local-bg">TP Member</th>
                  <th className="small border py-1 px-2 local-bg">
                    Unit Capped
                  </th>
                  <th className="small border py-1 px-2 local-bg">Stock</th>
                  <th className="small border py-1 px-2 local-bg">SKU</th>
                </tr>
                {variationData &&
                  variationData.length > 0 &&
                  variationData
                    .filter((item) => {
                      return (
                        item[variations.map((item) => item.name)[0]]?.trim()
                          .length !== 0
                      );
                    })
                    .map((row, rowIndex) => (
                      <tr className="" key={rowIndex}>
                        {variations &&
                          variations.length > 0 &&
                          variations.map((item, index) => (
                            <th
                              key={index}
                              className="border px-2 small text-muted"
                            >
                              {row[item.name] || " -"}
                            </th>
                          ))}
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text input_icon_left border-0"
                            type="number"
                            min="0"
                            id="teamPrice"
                            placeholder="Input"
                            name="teamPrice"
                            value={row.teamPrice}
                            icon="currency"
                            onChange={(e) =>
                              handleVariationDataChange(
                                e,
                                "teamPrice",
                                rowIndex
                              )
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="number"
                            min="0"
                            id="teamMembers"
                            placeholder="Input"
                            name="teamMembers"
                            value={row.teamMembers}
                            onChange={(e) =>
                              handleVariationDataChange(
                                e,
                                "teamMembers",
                                rowIndex
                              )
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="number"
                            min="0"
                            id="teamUnitCapped"
                            placeholder="Input"
                            name="teamUnitCapped"
                            value={row.teamUnitCapped}
                            onChange={(e) =>
                              handleVariationDataChange(
                                e,
                                "teamUnitCapped",
                                rowIndex
                              )
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="number"
                            min="0"
                            id="teamStock"
                            placeholder="Input"
                            name="teamStock"
                            value={row.teamStock}
                            onChange={(e) =>
                              handleVariationDataChange(
                                e,
                                "teamStock",
                                rowIndex
                              )
                            }
                            required={false}
                          />
                        </td>
                        <td className="border">
                          <InputField
                            disabled
                            formClass="col-12 p-0"
                            className="input-box input-inside-text pl-2 border-0"
                            type="text"
                            // min="0"
                            id="teamSku"
                            placeholder="Input (Optional)"
                            name="teamSku"
                            value={row.teamSku}
                            onChange={(e) =>
                              handleVariationDataChange(e, "teamSku", rowIndex)
                            }
                            required={false}
                          />
                        </td>
                      </tr>
                    ))}
              </table>
            </div>
          </form>
        </div>
        <br />
        <div
          id="specification"
          //   visible={String(steps == 3)}
          className="mr-3 ml-4 rounded  px-3 pt-4 pb-2 bg-white"
        >
          <h6 className="my-0">SPECIFICATION</h6>
          <form className="mt-3 p-0">
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small ">Brand</label>
              <div className="form-group col-9">
                <SelectInput
                  options={brandsList}
                  name="brand"
                  value={specification.brand}
                  onChange={(e) => onChangeSpecification(e, "brand", e)}
                  required={true}
                  formSubmitted={false}
                  placeholder="Select brand"
                  disabled
                />
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Ship From
              </label>
              <div className="form-group col-9">
                <SelectInput
                  options={countriesList}
                  name="shipFrom"
                  value={specification.shipFrom}
                  onChange={(e) => onChangeSpecification(e, "shipFrom", e)}
                  required={true}
                  formSubmitted={false}
                  placeholder="Select country"
                  disabled
                />
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                {basicInformation.type == "non-physical"
                  ? "Expiry Date"
                  : "Warranty Period"}
              </label>
              <div className="form-group col-9">
                {basicInformation.type == "non-physical" ? (
                  <InputField
                    className="pr-5"
                    formClass="p-0"
                    type="date"
                    min="0"
                    id="expiry-date"
                    placeholder="Input"
                    name="expiryDate"
                    value={specification?.expiryDate || ""}
                    onChange={onChangeSpecification}
                    required={true}
                    iconType="text"
                    iconLabel="Months"
                    iconPosition="right"
                    disabled
                  />
                ) : (
                  <InputField
                    className="pr-5"
                    formClass="p-0"
                    type="number"
                    min="0"
                    id="warranty-period"
                    placeholder="Input"
                    name="warrantyPeriod"
                    value={specification.warrantyPeriod}
                    onChange={onChangeSpecification}
                    required={true}
                    iconType="text"
                    iconLabel="Months"
                    iconPosition="right"
                    disabled
                  />
                )}
              </div>
            </div>
          </form>
        </div>
        <br />
        <div
          id="shipping-address"
          visible={String(
            basicInformation.type == "non-physical" ? false : true
          )}
          className="mr-3 ml-4 rounded mb-2 px-3 pt-4 bg-white"
        >
          <h6 className="my-0">SHIPPING INFORMATION</h6>
          <form className="mt-3 p-0">
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Weight
              </label>
              <div className="form-group col-9">
                <InputField
                  className="input_icon_right"
                  formClass="p-0"
                  type="number"
                  min="0"
                  max="30"
                  id="weight"
                  placeholder="Input"
                  name="weight"
                  icon="kg"
                  value={shippingInfo.weight}
                  onChange={onChangeShippingInfo}
                  required={true}
                  disabled
                />
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Parcel Size
              </label>
              <div className="form-group col-9 d-flex flex-wrap">
                <InputField
                  className="input_icon_left input_icon_right"
                  icon="width-cm"
                  formClass="col-4 p-0"
                  type="number"
                  min="0"
                  id="parcel-width"
                  placeholder="Input"
                  name="parcelWidth"
                  value={shippingInfo.parcelWidth}
                  onChange={onChangeShippingInfo}
                  required={true}
                  disabled
                />
                <InputField
                  className="input_icon_left input_icon_right"
                  icon="length-cm"
                  formClass="col-4 p-0"
                  type="number"
                  min="0"
                  id="parcel-length"
                  placeholder="Input"
                  name="parcelLength"
                  value={shippingInfo.parcelLength}
                  onChange={onChangeShippingInfo}
                  required={true}
                  disabled
                />
                <InputField
                  className="input_icon_left input_icon_right"
                  icon="height-cm"
                  formClass="col-4 p-0"
                  type="number"
                  min="0"
                  id="parcel-height"
                  placeholder="Input"
                  name="parcelHeight"
                  value={shippingInfo.parcelHeight}
                  onChange={onChangeShippingInfo}
                  required={true}
                  disabled
                />
              </div>
            </div>
            <div className="col-12 row my-3">
              <label className="col-3 text-right m-0 p-0 small imp">
                Shipping Fee
              </label>
              <div className="form-group col-9">
                <p>
                  You can also{" "}
                  <button href="#" className="btn bold" disabled>
                    Click Here
                  </button>{" "}
                  to enable more shipping channel.
                </p>
                <div className="card border">
                  <div className="card-header d-flex">
                    Delivery Fee: <div className="bold">RM0:0</div>
                  </div>
                  <div className="card-body">
                    {/* <p>DHL Express (max 30kg)</p> */}
                    <p>Flash (max 30kg)</p>
                  </div>
                </div>
                <p className="small text-muted">
                  Shipping settings will be applicable for this product only.
                  Shipping fees displayed are base rates and will be subject to
                  change depending on buyer and seller location.
                </p>
              </div>
            </div>
          </form>
        </div>
        <br />
        <div
          id="other-information"
          // visible={String(steps == 3)}
          className="mr-3 ml-4 rounded mb-2 px-3 pt-4 bg-white"
        >
          <h6 className="my-0">OTHERS</h6>
          <form className="mt-3 p-0">
            <div className="col-12 row my-3">
              <label className="col-3 text-right mx-0 mt-2 p-0 small imp">
                Pre-Order
              </label>
              <div className="form-group col-9">
                <RadioButtonsGroup
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                  name="preOrder"
                  className="col-9 px-3"
                  value={basicInformation.preOrder}
                  // onChange={(e) =>
                  //     onChangeBasicInfo(e, "preOrder", e.target.value)
                  // }
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="error_container mr-3 ml-4 rounded px-3 d-flex">
          {Object.values(errors).filter((item) => item).length ? (
            <label className="error fntSz14">
              {Object.values(errors)
                .filter((item) => item)
                .join(", ")}{" "}
              fields are missing or invalid!
            </label>
          ) : (
            <></>
          )}
        </div>
        <footer className="d-flex flex-wrap justify-content-end align-items-center py-3 my-3 bg-white border-top">
          <div className="col-md-4 d-flex  align-items-center mr-2 justify-content-end">
            <button
              type="button"
              className="btn input-inside-text btn-dark text-nowrap"
              onClick={() => history.goBack()}
            >
              Back
            </button>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default ViewProduct;
